// Paths of the REVA-REST API

export const PATH_AUTHORIZE = "/authorize";
/** #19351: let account-management send the verification link to the current user's stored address (POST). */
export const PATH_USER_EMAIL_VERIFICATION = "/user/email-verification";
/**
 * #19351: redeem an e-mail-verification token together with username+password proving account ownership
 * (POST, no credentials) — backs REVA's own page for links REVA triggered (`/verify-email?token=…`), as
 * opposed to the JSF `verifyEmail.html` page account-management still uses for its own mails.
 */
export const PATH_EMAIL_VERIFICATION_REDEEM = "/email-verification/redeem";
/** #19351: read/update full name, e-mail and language of the logged-in user (GET/PUT). */
export const PATH_USER_PROFILE = "/user/profile";
/** #19351: change the logged-in user's password (PUT). */
export const PATH_USER_PASSWORD = "/user/password";
/** #19351: check the logged-in user's current password before a password or e-mail change (POST). */
export const PATH_USER_PASSWORD_VERIFY = "/user/password/verify";
/** #19351: request a password-reset e-mail for a login name or e-mail address (POST, no credentials). */
export const PATH_PASSWORD_RESET_REQUEST = "/password-reset/request";
/** #19351: redeem a password-reset token together with a new password (POST, no credentials). */
export const PATH_PASSWORD_RESET_REDEEM = "/password-reset/redeem";
export const PATH_IMMODROP = "/immodrop/extract";
export const PATH_IMMODROP_FILE = `${PATH_IMMODROP}/file`;

/** Energy-certificate IDP (reva-rest proxy → IDP-Energy service POST /energy-certificate). */
export const PATH_IDP_ENERGY = "/idp/energy-certificate";

/** KI-Chat: eine Nutzernachricht rein, die Antwort der KI raus (POST, reva-rest → kiano, #19490). */
export const PATH_CHAT = "/chat";

export const PATH_GS = "/gs";
export const PATH_GS_WMTS = `${PATH_GS}/wmts`;

export const PATH_VALUATIONS = "/valuations";
export const PATH_VALUATIONS_SEARCH = `${PATH_VALUATIONS}/search`;
/**
 * #18907: Look up already existing valuations at the same address (coordinate + street/house number)
 * in the user's license before creating a new one (POST). See {@link SearchValuationsAtAddressApiInterface}.
 */
export const PATH_VALUATIONS_SEARCH_AT_ADDRESS = `${PATH_VALUATIONS}/search-at-address`;
/** Freitext-gefilterte Trefferzahlen je Tab für die Startseiten-Tab-Badges (POST). */
export const PATH_VALUATIONS_TAB_COUNTS = `${PATH_VALUATIONS}/tab-counts`;
/** #19113: Current age-distribution statistics of the POOL-tab order pool. */
export const PATH_VALUATIONS_POOL_STATISTICS = `${PATH_VALUATIONS}/pool-statistics`;
export const PATH_VALUATION_IMPORT_FROM_VALUE_API = `${PATH_VALUATIONS}/importFromValueApi`;
export const PATH_VALUATION_FINALIZE = "finalize";
export const PATH_VALUATION_PRE_FINALIZE = "preFinalize";
export const PATH_VALUATION_SNAPSHOTS = "snapshots";

// Final path segments for valuation lifecycle operations (appended after the valuation id).
export const PATH_VALUATION_DELETE = "delete";
export const PATH_VALUATION_DELETE_WITH_ORDER = "deleteWithOrder";
export const PATH_VALUATION_CORRECTION = "correction";
export const PATH_VALUATION_ASSIGN = "assign";
/** #19481: Zweckwechsel, z. B. Research → Bewertung. */
export const PATH_VALUATION_CHANGE_PURPOSE = "changePurpose";
export const PATH_VALUATION_ASSIGNABLE_USERS = "assignableUsers";
/**
 * Users a valuation may be handed to as its new owner when reopening it for a correction: only users who
 * may finalize, snapshot authors of this valuation first (see reva-rest listFinalizeAssignableUsers).
 */
export const PATH_VALUATION_FINALIZE_ASSIGNABLE_USERS = "finalizeAssignableUsers";

/** Refresh Address of a valuation */
export const PATH_VALUATION_ADDRESS_REFRESH = "address/refresh";

// Value-Order-API documents of a valuation (appended after the valuation id).
export const PATH_VALUATION_DOCUMENTS = "documents";

// Beauftragen bei der ValueAG (appended after the valuation id).
export const PATH_VALUATION_VALUE_ORDERS = "valueOrders";
export const PATH_VALUATION_COMMISSION_VALUE_ORDER = "commissionValueOrder";

// Final path segments for persisting a single parameter / document property of a valuation
// (appended after the valuation id). AVM uses the bare valuation path (no extra segment).
export const PATH_VALUATION_PROPERTIES = "properties";
export const PATH_VALUATION_ENERGY_CERTIFICATE = "energyCertificate";
export const PATH_VALUATION_IDP_ENERGY_CERTIFICATE = "idpEnergyCertificate";
export const PATH_VALUATION_REGISTER = "register";
export const PATH_VALUATION_INSPECTION_DERIVED = "inspectionDerived";
export const PATH_VALUATION_PLOT = "plot";
export const PATH_VALUATION_IMMODROP = "immodrop";

/**
 * Freigeschaltete Auftragsarten und Gebäudearten beim ValueAG-Auftraggeber der Lizenz des angemeldeten Benutzers
 * (GET, reva-rest cacht die Orders-API-Antwort). Grundlage dafür, ob REVA das Beauftragen überhaupt anbietet.
 */
export const PATH_VALUE_ORDERS_ENTITLEMENTS = "/value-orders/entitlements";

export const PATH_REVA_PDF = "/pdf";

export const PATH_MARKETDATA = "/marketdata";

// #19113: Cross-valuation list/statistics of the current user's snapshots (DONE tab of the start page).
export const PATH_SNAPSHOTS = "/snapshots";
export const PATH_SNAPSHOTS_SEARCH = `${PATH_SNAPSHOTS}/search`;
export const PATH_SNAPSHOTS_STATISTICS = `${PATH_SNAPSHOTS}/statistics`;
// #19113: Same views but over all users' snapshots (Admin tab); require reva-ownership-admin.
export const PATH_SNAPSHOTS_ADMIN_SEARCH = `${PATH_SNAPSHOTS}/admin/search`;
export const PATH_SNAPSHOTS_ADMIN_STATISTICS = `${PATH_SNAPSHOTS}/admin/statistics`;
